import ImageUploading, { ImageListType } from 'react-images-uploading';

import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

interface MeterUploadPicturesProps {
	images?: ImageListType[];
	containerEl?: string;
	maxNumber?: number;
	maxFileSize?: number;
	acceptType?: string[];
	onImagesChange: (images: ImageListType[]) => void;
}
function MeterUploadPictures({
	images = [],
	containerEl = 'images-container',
	maxNumber = 4,
	maxFileSize = 6291456,
	acceptType = ['jpg', 'jpeg', 'png'],
	onImagesChange,
}: MeterUploadPicturesProps) {
	const { t } = useTranslation();

	const onChange = (imageList: ImageListType) => {
		onImagesChange(imageList as ImageListType[]);
	};

	const container = document.getElementsByClassName(containerEl)[0];

	return (
		<div className='container-fluid meter-upload-pictures'>
			<ImageUploading
				multiple
				value={images}
				onChange={onChange}
				acceptType={acceptType}
				maxNumber={maxNumber}
				maxFileSize={maxFileSize}
				dataURLKey='data_url'
			>
				{({
					imageList,
					onImageUpload,
					onImageRemoveAll,
					onImageUpdate,
					onImageRemove,
					isDragging,
					dragProps,
					errors,
				}) => (
					<div className='row meter-upload-pictures upload-image__wrapper'>
						<button
							className='btn btn--primary btn--block upload-image__upload-btn'
							type='button'
							onClick={onImageUpload}
							style={isDragging ? { backgroundColor: '#f6c7e8' } : undefined}
							{...dragProps}
						>
							<div className='btn__text'>{t('common.upload.label')}</div>
							<div className='btn__text--small'>
								{t('common.upload.caption')}
							</div>
						</button>
						{errors && (
							<div className='upload-image__errors__container'>
								<p className='arrow-container mb-4'>
									<span className='up-arrow'></span>
								</p>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									fill='none'
									viewBox='0 0 24 24'
									stroke-width='1.5'
									stroke='currentColor'
									className='icon me-2'
								>
									<path
										stroke-linecap='round'
										stroke-linejoin='round'
										d='M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z'
									></path>
								</svg>
								{(errors.maxNumber || images.length >= maxNumber) && (
									<span>{t('common.upload.error.max-number')}</span>
								)}
								{errors.acceptType && (
									<span>{t('common.upload.error.file-type')}</span>
								)}
								{errors.maxFileSize && (
									<span>{t('common.upload.error.file-size')}</span>
								)}
							</div>
						)}

						{container &&
							createPortal(
								imageList.map((image, index) => (
									<div className=' col-12 col-md-6 pr-1' key={index}>
										<div key={index} className='upload-image__item'>
											<div className='upload-image__item__img-block'>
												<img src={image['data_url']} alt='' width='100' />
												<div>
													{image.file?.name}
													<div className='file-size'>
														{(image.file?.size! / (1024 * 1024)).toFixed(2)}
														&nbsp;MB
													</div>
												</div>
											</div>

											<div className=' upload--image__item__btn-wrapper'>
												<button
													type='button'
													className='upload-image__item__btn-remove'
													onClick={() => onImageRemove(index)}
												>
													<svg
														xmlns='http://www.w3.org/2000/svg'
														fill='none'
														viewBox='0 0 24 24'
														strokeWidth='1.5'
														stroke='currentColor'
														className='icon'
													>
														<path
															strokeLinecap='round'
															strokeLinejoin='round'
															d='m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0'
														/>
													</svg>
												</button>
											</div>
										</div>
									</div>
								)),

								container
							)}
					</div>
				)}
			</ImageUploading>
		</div>
	);
}

export default MeterUploadPictures;
